import React, { useState } from "react";
import { Header } from "../Component/Header";
import { toast } from "react-toastify";

export const Singup = () => {
  const [user, setUser] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const onToast = (msg) => {
    if (msg === "Signup Successfull!!") {
      toast.success(msg, {
        position: "top-center",
      });
    } else {
      toast.error(msg, {
        position: "top-center",
      });
    }
  };

  const handleSinup = async (e) => {
    e.preventDefault();

    if (user.password !== user.confirmPassword) {
      onToast("Password not match!!");
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/singup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: user.name,
          email: user.email,
          password: user.password,
        }),
      });

      const data = await res.json();

      if (res.status === 200) {
        onToast("Signup Successfull!!");

        setTimeout(() => {
          window.location.href = "/login";
        }, 1500);
      } else {
        onToast("Something went wrong!!");
      }

      console.log(data);
    } catch (err) {
      console.log(err);
      onToast("Server error!!");
    }
  };

  return (
      <>
        <Header />

        <div
            className="d-flex flex-column justify-content-center"
            id="login-box"
        >
          <div className="login-box-header">
            <h4>Create an Account</h4>
          </div>

          <div className="login-box-content">
            <div className="email-login">

              <input
                  type="text"
                  className="form-control"
                  placeholder="Name"
                  value={user.name}
                  onChange={(e) =>
                      setUser({ ...user, name: e.target.value })
                  }
              />

              <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={user.email}
                  onChange={(e) =>
                      setUser({ ...user, email: e.target.value })
                  }
              />

              <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  value={user.password}
                  onChange={(e) =>
                      setUser({ ...user, password: e.target.value })
                  }
              />

              <input
                  type="password"
                  className="form-control"
                  placeholder="Confirm Password"
                  value={user.confirmPassword}
                  onChange={(e) =>
                      setUser({
                        ...user,
                        confirmPassword: e.target.value,
                      })
                  }
              />

              <button
                  className="btn btn-primary w-100 mt-3"
                  onClick={handleSinup}
              >
                Sign Up
              </button>

            </div>
          </div>
        </div>
      </>
  );
};